var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_abnormalClockin_form_title"),
      backgroundClass: "transparent",
      widthClass: "max-1000",
      pad: "0",
      editBtn: !_vm.iSEdited && Number(_vm.approval_status) === 0 && false,
      initData: {},
      checkData: [],
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u(
      [
        _vm.Data
          ? {
              key: "page-main",
              fn: function () {
                return [
                  _vm.Data
                    ? _c("ApprovalTriger", {
                        attrs: {
                          "bg-color": _vm.Data.approval_bg_color,
                          "slide-color": _vm.Data.approval_tint_color,
                        },
                        on: {
                          triger: function ($event) {
                            return _vm.$toPage(
                              "/admin/abnormal-clock-in/detail/" +
                                _vm.$route.params.params +
                                "/approval-detail/" +
                                _vm.$route.params.params
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "time",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getDateTime(
                                          _vm.Data.operate_utc_datetime,
                                          "YYYY/MM/DD HH:mm"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          _vm.Data.status_detail
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2072884572
                        ),
                      })
                    : _vm._e(),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_swiftNumberLabel"
                                        )
                                      )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_swiftNumberLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.Data.swift_number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.Data, "swift_number", $$v)
                                  },
                                  expression: "Data.swift_number",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_submitDateLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.submission_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_submitDateLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_applicatLabel"
                                        )
                                      )
                                  ),
                                ]
                              ),
                              _c("v-autocomplete", {
                                attrs: {
                                  "single-line": "",
                                  readonly: "",
                                  items: _vm.users,
                                  "append-icon": "",
                                  "item-value": "uuid",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "no-data",
                                      fn: function () {
                                        return [_c("noContent")]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "v-chip",
                                            _vm._b(
                                              {
                                                attrs: {
                                                  pill: "",
                                                  "input-value": data.selected,
                                                },
                                              },
                                              "v-chip",
                                              data.attrs,
                                              false
                                            ),
                                            [
                                              _c("StaffAvatar", {
                                                attrs: {
                                                  left: "",
                                                  src: data.item.staff_avatar,
                                                  staff_name:
                                                    data.item.preferred_name,
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.preferred_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4123812085
                                ),
                                model: {
                                  value: _vm.user,
                                  callback: function ($$v) {
                                    _vm.user = $$v
                                  },
                                  expression: "user",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_punchDateLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.punch_utc_datetime,
                                    "YYYY/MM/DD"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_punchDateLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_actualPunchTimeLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.punch_utc_datetime,
                                    "HH:mm"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_actualPunchTimeLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "pa-0 ma-0 d-flex flex-row",
                          attrs: { fluid: "" },
                        },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "pa-0 ma-0 flex-shrink-1",
                              staticStyle: { width: "45%" },
                              attrs: { fluid: "" },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text-subtitle-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_abnormalClockin_form_failItemIitleLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              !Number(_vm.Data.gps_criteria_matched)
                                ? _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "my-2 d-flex align-center flex-row",
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "24",
                                          fill: "transparent",
                                          iconClass: "Alert",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-body-2 px-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_abnormalClockin_form_punchtype_GPSLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !Number(_vm.Data.wifi_criteria_matched)
                                ? _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "my-2 d-flex align-center flex-row",
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "24",
                                          fill: "transparent",
                                          iconClass: "Alert",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-body-2 px-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_abnormalClockin_form_punchtype_WiFiLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !Number(_vm.Data.bluetooth_criteria_matched)
                                ? _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "my-2 d-flex align-center flex-row",
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          size: "24",
                                          fill: "transparent",
                                          iconClass: "Alert",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-body-2 px-2" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_abnormalClockin_form_punchtype_BluetoothLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            {
                              staticClass:
                                "\n            pa-0\n            ma-0\n            flex-grow-1\n            rounded-lg\n            mrc-border-solid\n            scroll_content_no\n          ",
                              staticStyle: { position: "relative" },
                              attrs: { fluid: "" },
                            },
                            [
                              _c(
                                "GmapMap",
                                {
                                  ref: "abnormalMap",
                                  staticStyle: {
                                    width: "100%",
                                    height: "600px",
                                  },
                                  attrs: {
                                    center: _vm.center,
                                    zoom: 18,
                                    options: {
                                      zoomControl: false,
                                      mapTypeControl: false,
                                      scaleControl: false,
                                      streetViewControl: false,
                                      rotateControl: false,
                                      keyboardShortcuts: false,
                                      gestureHandling: "greedy",
                                      fullscreenControl: false,
                                      disableDefaultUi: false,
                                    },
                                    "map-type-id": "roadmap",
                                  },
                                },
                                [
                                  _c("GmapMarker", {
                                    attrs: {
                                      option: {
                                        animation: "drop",
                                        shape: "circle",
                                      },
                                      position: _vm.markers,
                                      icon: _vm.makericon,
                                      clickable: true,
                                      draggable: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setCenter(_vm.markers)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-row",
                        [
                          _vm.Data.attachments
                            ? _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_abnormalClockin_form_attachmentLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("ImgDragUpdate", {
                                    attrs: {
                                      defaultImageList: _vm.Data.attachments,
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_reasonLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_reasonLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.Data.invalid_reason_text,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.Data,
                                      "invalid_reason_text",
                                      $$v
                                    )
                                  },
                                  expression: "Data.invalid_reason_text",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_abnormalClockin_form_messageLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  label: _vm.$t(
                                    "label_essweb_abnormalClockin_form_messageLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.Data.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.Data, "remarks", $$v)
                                  },
                                  expression: "Data.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "page-actions",
          fn: function () {
            return [
              _vm.iSEdited
                ? _c("CardActions", {
                    attrs: { saveBtn: "" },
                    on: {
                      save: _vm.toSave,
                      cancel: function ($event) {
                        return _vm.$toBack(_vm.isChanged)
                      },
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }